import React, { useEffect, useState } from "react";
import { api, fmtNum, fmtMoney } from "@/lib/api";

export default function PaperPositions() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const load = async () => {
      const { data } = await api.get("/paper-positions");
      setRows(data);
    };
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-4" data-testid="positions-page">
      <h1 className="text-2xl font-medium tracking-tight">Paper Positions</h1>
      <p className="text-xs text-slate-500 uppercase tracking-[0.15em]">
        Open paper positions with live stop &amp; target
      </p>
      <div className="surface rounded-sm overflow-x-auto">
        <table className="dt">
          <thead>
            <tr>
              <th>Status</th>
              <th>Symbol</th>
              <th>Underlying</th>
              <th>Type</th>
              <th className="num">Lots × Qty</th>
              <th className="num">Entry</th>
              <th className="num">Stop Trigger</th>
              <th className="num">Stop Limit</th>
              <th className="num">Target</th>
              <th className="num">Net Risk</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.id || i} data-testid="position-row">
                <td className="text-pos text-[10px] uppercase tracking-[0.15em]">{r.status}</td>
                <td className="font-mono">{r.tradingsymbol}</td>
                <td>{r.underlying}</td>
                <td>{r.option_type}</td>
                <td className="num font-mono">{r.lots} × {r.quantity / r.lots}</td>
                <td className="num font-mono">{fmtNum(r.entry_price)}</td>
                <td className="num font-mono text-neg">{fmtNum(r.stop_trigger)}</td>
                <td className="num font-mono text-neg">{fmtNum(r.stop_limit)}</td>
                <td className="num font-mono text-pos">{fmtNum(r.target_price)}</td>
                <td className="num font-mono">{fmtMoney(r.net_risk)}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan="10" className="text-center text-slate-500 py-10">No open positions.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
